/**
 *  Log / Report
 *   =->  현재상태 Store
 *
 * @since 2018-07-23
 * @author dev013
 */

import {LogReportApiPrefix as logReportApiPreFix} from 'utils'
import {pcDownloadFile} from '../../../utils/files'
import {i18n} from '../../../plugins/i18n'
import JSONBigInt from 'json-bigint'

// TAMS
const initSearchData = () => {
  return {
    id: '',
    page_num: 1,
    // TAMS
    device_id: 0
  }
}
function getDeleteApiPrePath () {
  return {
    'NAT4_SESSION': '/api/po/nat/session', //  [방화벽 상태] NAT 현재 세션 삭제
    'NAT6_SESSION': '/api/po/nat6/session', //  [방화벽 상태] NAT 현재 세션 삭제
    'FW4_SESSION': '/api/po/fw/4/session', //  [방화벽 상태] 방화벽 현재 세션 삭제 (IPv4)
    'FW6_SESSION': '/api/po/fw/6/session', // [방화벽 상태] 방화벽 현재 세션 삭제 (IPv6)
    'BLACKLIST': '/api/po/blacklist/logs', // [블랙리스트] (IPv4, IPv6) 삭제, 전체 삭제
    'ARP4_TABLE': '/api/sm/arp/logs', //       [네트워크 상태] ARP 테이블 삭제
    'ARP6_TABLE': '/api/sm/ipv6/ndp/logs', // [네트워크 상태] IPv6 NDP 테이블 삭제
    'VPN_BRANCH_INFO': '/api/vp/ipsec/status/branch', //    [VPN 상태] 지점 터널 정보 보기 삭제
    'VPN_USER_INFO': '/api/vp/ipsec/status/remote-user', // [VPN 상태] 원격 사용자 터널 보기 삭제
    'IPS_ATTACKER_LIST': '/api/op/ips/status' // [IPS/DDOS 상태] 공격자 목록 출력 전체 삭제
  }
}
function getFwUserAuthPath () {
  return {
    'LOGOUT': '/api/po/auth/users/logout', //                           사용자 선택, 전체 로그아웃
    'DELETE': '/api/po/auth/users/delete', //                           사용자 조건 삭제
    'AUTH_USERS': '/api/po/auth/users', //                              Manual 인증 사용자 수동 추가
    'AUTH_USER_BATCH_HISTORY': '/api/po/auth/users/batch/history', //   인증 사용자 배치 이력 조회
    'AUTH_USER_RESTORE': '/api/po/auth/users/restore' //                인증 사용자 복구
  }
}

function getDelConditionGui () {
  return {
    fwIdAny: 0,
    vlanIdAny: 0,
    natruleIdAny: 0,
    srcIpAny: 0,
    srcPortAny: 0,
    dstIpAny: 0,
    dstPortAny: 0
  }
}

function delConditionParam () {
  return {
    fw_rule_id: '',
    vlan: '',
    nat_rule_id: '',
    sip: '',
    sip_mask: '',
    sport: '',
    dip: '',
    dip_mask: '',
    dport: '',
    proto: 0
  }
}

function delUserCriteriaParam () {
  return {
    dmn: '',
    auth_type: {
      portal: 0,
      admin: 0,
      ad: 0,
      agent: 0,
      syslog: 0,
      xml: 0,
      ipmap: 0,
      saml: 0,
      sslvpn: 0
    }
  }
}

function getHaUserParam () {
  return { user_id: '', user_passwd: '' }
}

function getFwAuthUsersParam () {
  return {
    usr_id: '',
    ip: '',
    idle: 60,
    timeout: 720
  }
}

function getPolicyAutoCreateParam (params = {}) {
  const defaultFormat = {
    src: '',
    src_mask: 1,
    src_zone: 1, // 내부: 1, 외부: 2, DMZ: 3 //
    src_port: '',
    user_id: '',
    dst: '',
    dst_mask: 1,
    dst_zone: 1, // 내부: 1, 외부: 2, DMZ: 3
    dst_port: '',
    app: '',
    protocol: '',
    action: 1, // 허용: 1, 거부: 2, 거절(ICMP): 3, 거절(Reset): 4
    apply_action: 1 // 저장만: 1, 저장 후 적용: 2
  }
  return {...defaultFormat, ...params}
}

function getSearchState () {
  return {
    status: '', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0,
    selectPageCnt: 30
  }
}

function getSearchData () {
  return {
    filters: [],
    data_type: '',
    page_rows: 30,
    total_rows: 1000
  }
}

function getDeleteApiParam (state, delFlag) {
  let param = {}, apiPath = state.deleteApiPrePath[state.dataType.toUpperCase()]
  if (['nat4_session', 'nat6_session'].includes(state.dataType)) { // [방화벽 상태] NAT 현재 세션 삭제, 조건 삭제
    if (delFlag === 'Condition') { // 조건 삭제
      convertAnyFormat(state)
      param = _.cloneDeep(state.delConditionParam)
      delete param.fw_rule_id
      delete param.vlan
    } else { // 세션 삭제
      param = {
        'nat_rule_id': Number(state.selectedItem[0].nat_rule_id),
        'sip': convertIp(state.selectedItem[0].src_ip),
        'sip_mask': null,
        'sport': Number(state.selectedItem[0].src_port),
        'dip': convertIp(state.selectedItem[0].dst_ip),
        'dip_mask': null,
        'dport': Number(convertIp(state.selectedItem[0].dst_port)),
        'proto': state.selectedItem[0].protocol_raw
      } // 세션 삭제
    }
  } else if (['fw6_session', 'fw4_session'].includes(state.dataType)) { // [방화벽 상태] [현재 세션, IPv6 방화벽] 현재 세션 삭제, 조건 삭제
    if (delFlag === 'Condition') { // 조건 삭제
      convertAnyFormat(state)
      param = _.cloneDeep(state.delConditionParam)
      delete param.nat_rule_id
    } else { // 세션 삭제
      param = {
        'fw_rule_id': Number(state.selectedItem[0].fw_rule_id),
        'vlan': Number(state.selectedItem[0].vlan_id),
        'sip': convertIp(state.selectedItem[0].src_ip) || '',
        'sip_mask': null,
        'sport': Number(state.selectedItem[0].src_port),
        'dip': convertIp(state.selectedItem[0].dst_ip),
        'dip_mask': null,
        'dport': Number(convertIp(state.selectedItem[0].dst_port)),
        'proto': state.selectedItem[0].protocol_raw
      }
    }
    // [블랙리스트] IPv4 블랙리스트,  IPv6 블랙리스트
  } else if (['blacklist4', 'blacklist6'].includes(state.dataType)) {
    apiPath = state.deleteApiPrePath['BLACKLIST']
    if (delFlag === 'ALL') { // 전체 삭제
      param = { del_all: 1, ip_ver: state.dataType === 'blacklist6' ? 2 : 1 }
    } else { // 선택 삭제
      const itemInfo = {
        ip_ver: state.dataType === 'blacklist6' ? 2 : 1, // (1:ipv4, 2:ipv6)
        src_ip: state.selectedItem[0].src_ip,
        dst_ip: state.selectedItem[0].dst_ip,
        src_port: state.selectedItem[0].src_port,
        dst_port: state.selectedItem[0].dst_port,
        prtc: state.selectedItem[0].protocol_raw,
        type: state.selectedItem[0].type_id_raw
      }
      param = {
        del_all: 0,
        ip_ver: itemInfo.ip_ver, // (1:ipv4, 2:ipv6)
        src_ip: getAnyDefault(itemInfo.src_ip, 0),
        dst_ip: getAnyDefault(itemInfo.dst_ip, 0),
        src_port: Number(convertPort(itemInfo.src_port)[0]), // 0-65535
        src_port_e: Number(convertPort(itemInfo.src_port)[1]), // 0-65535
        dst_port: Number(convertPort(itemInfo.dst_port)[0]), // 0-65535
        dst_port_e: Number(convertPort(itemInfo.dst_port)[1]), // 0-65535F
        prtc: itemInfo.prtc,
        type: itemInfo.type
      }
    }
  } else if (state.dataType === 'arp4_table') { // [네트워크 상태] ARP 테이블
    if (delFlag === '') { // 선택 삭제
      param = {
        ip: state.selectedItem[0].ip,
        dev: state.selectedItem[0].if_name,
        mac: state.selectedItem[0].mac
      }
      apiPath = `${apiPath}/${state.selectedItem[0].ip}/${state.selectedItem[0].if_name}`
    }
  } else if (state.dataType === 'arp6_table') { // [네트워크 상태] IPv6 NDP 테이블
    if (delFlag === '') { // 선택 삭제
      param = {
        ip: state.selectedItem[0].ip,
        dev: state.selectedItem[0].if_name,
        mac: state.selectedItem[0].mac
      }
      apiPath = `${apiPath}/${state.selectedItem[0].ip}/${state.selectedItem[0].mac}/${state.selectedItem[0].if_name}`
    }
  } else if (state.dataType === 'vpn_branch_info') { // [VPN 상태] 지점 터널 정보 보기
    if (delFlag === '') param = { name: state.selectedItem[0].name } // 선택 삭제
  } else if (state.dataType === 'vpn_user_info') { // [VPN 상태] 원격 사용자 터널 정보 보기
    if (delFlag === '') param = { name: state.selectedItem[0].admin_id } // 선택 삭제
  } else if (state.dataType === 'ips_attacker_list') { // [IPS/DDOS 상태] 공격자 목록 출력 전체 삭제, IPS / DDOS 전체 삭제 시 Reset Path로 수정
    if (delFlag === 'ALL') {
      apiPath += '/attacker/reset' // 전체 삭제 시 Reset Path 추가
      param = { ipv6_only: 0 } // 파라미터 추가
    } else {
      apiPath += '/attackers' // 전체 삭제 시 Reset Path 추가
      param = { del_ip_list: state.selectedItem.map(row => row.src_ip) } // 전체 삭제가 아닌 경우 파라미터 추가
    }
  }
  return { apiPath, param }
}

export const state = () => ({
  apiPreFix: `${logReportApiPreFix}/current`, // TAMS
  aptFailOverPath: '/api/sm/ha/virtual-ips/failover-mode',
  statusApiPreFix: `${logReportApiPreFix}/current/status`, // TAMS
  saveApiPreFix: `${logReportApiPreFix}/current/save`, // TAMS, 미사용
  deleteApiPrePath: getDeleteApiPrePath(),
  fw_userauthApiPath: getFwUserAuthPath(),
  ha_resetApiPath: {
    'HA_STATUS': '/api/sm/ha/reset', //                           HA 멤버 상태 > HA 초기화
    'VIP_STATUS': '/api/sm/ha/virtual-ips/failure-recovery' // HA 가상 IP 주소 > 수동 장애복구
  },
  vpn_restartApiPreFix: '/api/vp/ipsec/status/restart', //         [VPN 상태] 재시작
  policyAutoCreatePreFix: '/api/po/fw/4/session/save/rule', //      [방화벽 상태] 정책 자동 생성 팝업
  contentAptNotifyPreFix: '/api/op/aptdb/detect/notifications', // [콘텐츠 보안 상태] APT-DB/URL 신고기능
  contentAptDbBehaviorBased: '/api/op/aptdb/behavior-based/targets', // [콘텐츠 보안 상태] APT / URL DB 사용, 미사용 기능
  processStatusApiPath: {
    'RELOAD': '/api/sm/process/reload', //  [시스템 상태] 프로세스 현황
    'RESTART': '/api/sm/process/restart' // [시스템 상태] 프로세스 현황
  },
  natConfigPreFix: '/api/po/nat/config', // [NAT 현재 세션] NAT 고급 설정 REST API-HA 콤보 활성화 확인용,
  natV6ConfigPrefix: '/api/po/nat6/config', // [NAT V6 현재 세션] NAT 고급 설정 REST API-HA 콤보 활성화 확인용,
  accessUserLogoutPreFix: '/api/au/logout', // [시스템 상태-현재접속중인 관리자] Level3 계정인 경우 타 계정 로그 아웃 기능
  wipsSensorStatusPrefix: '/api/lr/wips/sensor_status',
  dataType: 'system_info',
  selectedItem: [],
  delConditionGui: getDelConditionGui(), // 조건 삭제 시 GUI 정보
  delConditionParam: delConditionParam(), // 조건 삭제 시 API 로 전달되는 Param 정보,
  delUserCriteriaParam: delUserCriteriaParam(), // [방화벽 상태] 현재상태 사용자 조건 삭제 정보
  haUserParam: getHaUserParam(), // 수동 장애 복구 수행시 정보,
  fw_authUsersParam: getFwAuthUsersParam(), // 인증 사용자 수동 추가시 정보
  policyAutoCreateGui: { // 정책 자동 생성 시 Any 선택 여부
    srcPortAny: 0,
    dstPortAny: 0
  },
  policyAutoCreateParam: getPolicyAutoCreateParam(), // 정책 자동 생성 정보,
  // ===  onSearch ===
  search: initSearchData(), // TAMS
  searchState: getSearchState(),
  dataList: [],
  protocolList: [],
  userBatchDataList: [],
  userRestoreTargetList: [],
  logDetailDownErr: '',
  natConfigInfo: {},
  natV6ConfigInfo: {},
  vipFailOverMode: 0,
  wipsSensorCnt: { // WIPS 센서 현재 상태 -> 동작 / 미동작 센서 갯수 정보
    total: 0, // 전체
    active: 0, // 작동
    inactive: 0 // 미작동
  },
  searchData: getSearchData(), // 현재 상태 보기 요청 파라미터
  wipsLastSearchOpt: {} // WIPS 센서 현재 상태 파일 -> 최근 유효 검색 정보를 파일 다운로드 요청 시 파라미터로 사용
})

export const mutations = {
  // 현재 상태 보기 초기화 관련
  // 모든 스토어 데이터를 초기상태로 돌린다.
  initStoreData (state) {
    // REST API 파라미터 초기화
    state.searchData = {
      filters: [],
      data_type: '',
      page_rows: 30,
      total_rows: 1000
    }

    state.dataList = []
    state.protocolList = []
    state.userBatchDataList = []
    state.userRestoreTargetList = []
    state.logDetailDownErr = ''
    state.natConfigInfo = {}
    state.natV6ConfigInfo = {}
    state.selectedItem = []
    state.wipsSensorCnt = {
      total: 0, // 전체
      active: 0, // 작동
      inactive: 0 // 미작동
    }
    // TAMS
    state.search = initSearchData()
    state.wipsLastSearchOpt = {}
  },
  setDataType (state, type) {
    state.dataType = type
    state.searchData.data_type = type
  },
  // 화면에 출력되는 데이터 테이블 모델만 초기화한다.
  initDataList (state) {
    state.dataList = []
  },
  // 현재 상태 검색 상태를 초기화한다.
  initStatusState (state) {
    state.searchState = getSearchState()
  },
  // 차트 데이터, 테이블 데이터, REST API 파라미터 초기화
  errorSearch (state) {
    state.searchData = getSearchData()
    state.dataList = []
    state.protocolList = []
    state.userBatchDataList = []
    state.userRestoreTargetList = []
    state.logDetailDownErr = ''
    state.selectedItem = []
  },
  // 현재 상태 시작 후 RequestId를 설정
  startStatusSearch (state, data) {
    state.dataList = [] // 현재 상태 데이터 초기화
    state.search.id = data.request_id // 로그 조회 API ID 초기화
    state.search.device_id = data.device_id // 로그 조회 Device ID 초기화 (TAMS)
  },
  // 검색 종료 후 조회 ID 초기화
  endSearch (state) {
    state.search.id = ''
  },
  setDetailDownErrMsg (state, data) {
    state.logDetailDownErr = data
  },
  // 전달된 로그 데이터를 현재 데이터 뒤부터 붙인다.
  appendLogDataList (state, newLogList) {
    for (const newLog of newLogList) {
      state.dataList.push(newLog)
    }
  },
  // 전달된 로그 데이터로 업데이트한다.
  updateLogDataList (state, newLogList) {
    state.dataList = newLogList
  },
  // 현재 상태 보기 목록에서 선택된 Row 정보를 초기화한다.
  setSelectedItem (state, data) {
    state.selectedItem = data
  },
  // 프로토콜 목록을 초기화한다.
  setProtocolList (state, {result, isAny}) {
    state.protocolList = []
    if (isAny) {
      state.protocolList.push({label: 'ANY', value: 0})
    }
    _.forEach(result, (value) => {
      state.protocolList.push({
        label: value.name,
        value: value.prtc
      })
    })
  },
  // 인증 사용자 배치 이력 조회
  getUserBatchHistory (state, data) {
    state.userBatchDataList = data
  },
  // NAT 고급 설정 조회
  getNatConfig (state, data) {
    state.natConfigInfo = data
  },
  // NAT V6 고급 설정 조회
  setNatV6Config (state, data) {
    state.natV6ConfigInfo = data
  },
  // 조건 삭제 시 GUI 정보 초기화
  clearDelConditionGui (state) {
    state.delConditionGui = getDelConditionGui()
  },
  // 조건 삭제 시 API 로 전달되는 Param 정보 초기화
  clearDelConditionParam (state) {
    state.delConditionParam = delConditionParam()
  },
  // 사용자 조건 삭제 정보 초기화
  clearDelUserCriteriaParam (state) {
    state.delUserCriteriaParam = delUserCriteriaParam()
  },
  // 정책 자동 생성 정보 초기화
  setPolicyAutoCreateParam (state) {
    const selectRow = state.selectedItem[0]
    state.policyAutoCreateParam = getPolicyAutoCreateParam({
      src: convertIp(selectRow.src_ip),
      src_mask: 32,
      src_port: convertAnyPort(String(selectRow.src_port)),
      user_id: selectRow.user_id,
      dst: convertIp(selectRow.dst_ip),
      dst_mask: 32,
      dst_port: convertAnyPort(convertIp(String(selectRow.dst_port))),
      app: selectRow.app_id === '-' ? '' : selectRow.app_id,
      protocol: selectRow.protocol
    })
  },
  // 트래픽 세션 로그에서 정책 자동 생성 정보를 초기화한다.
  setPolicyAutoCreateParamFromLog (state, {src_ip: srcIp, src_port: srcPort, dst_ip: dstIp, dst_port: dstPort, user_id: userId, app_id: appId, protocol}) {
    state.policyAutoCreateParam = getPolicyAutoCreateParam({
      src: convertIp(srcIp),
      src_mask: 32,
      src_port: convertAnyPort(String(srcPort)),
      user_id: userId,
      dst: convertIp(dstIp),
      dst_mask: 32,
      dst_port: convertAnyPort(convertIp(String(dstPort))),
      app: appId === '-' ? '' : appId,
      protocol: protocol
    })
  },
  // 가상 IP 소유권 넘김 Flag 값을 스토어에 저장한다.
  setVipFailOverMode (state, mode) {
    state.vipFailOverMode = mode
  },
  setWipsSensorCnt (state, {stat = {active: 0, inactive: 0, total: 0}, meta = { total: 0 }}) {
    state.wipsSensorCnt = _.assign(stat, {
      page_total: meta.total
    })
  },
  setLastSearchOpt (state, opt) {
    state.wipsLastSearchOpt = opt
  }
}
export const actions = {
  // 현재 상태 검색 시작을 요청한다.
  async startStatusSearch ({commit, state}, {isWips = false, pageNum = 1}) {
    let res = { code: 'ok', result: {} } // TAMS
    const apiUrl = isWips ? state.wipsSensorStatusPrefix : `${state.apiPreFix}/start`
    const requestParam = { device_id: _.cloneDeep(state.searchData.device_id) } // TAMS (device_id)
    if (isWips) {
      requestParam.page_no = pageNum
      requestParam.page_count = state.searchData.page_rows
      _.forEach(state.searchData.filters, filter => {
        if (filter.key === 'active') {
          requestParam[filter.key] = Number(filter.value[0])
          return
        }
        requestParam[filter.key] = filter.value
      })
      try {
        res = await this.$axios.$post(apiUrl, requestParam, {loading: false, successAlert: false})
        if (res.code === 'ok') {
          commit('initDataList')
          commit('appendLogDataList', res.result.list)
          commit('setLastSearchOpt', requestParam)
          commit('setWipsSensorCnt', res.result)
        }
      } catch (e) {
        res.code = 'nok'
        res.result.msg = e.message
      }
    } else {
      try {
        res = await this.$axios.$post(apiUrl, state.searchData, {loading: false, successAlert: false})
        if (res.code === 'ok') commit('startStatusSearch', _.merge(res.result, requestParam)) // TAMS (searchDevice)
        else commit('errorSearch')
      } catch (e) {
        res.code = 'nok'
        res.result.msg = e.message
        commit('errorSearch')
      }
    }

    return res
  },
  // 현재 상태 조회 정보를 요청한다. keepAlive 파라미터가 True인 경우 서버로부터 요청만 전달한다.
  async getSearchState ({state}, keepAlive = false) {
    let res = { code: 'ok', result: {} } // TAMS

    if (state.search.id === undefined || state.search.id === '') {
      if (keepAlive) return // Keep Alive 요청 시 Request ID가 빈 문자열이면 API 요청을 중지한다
      res.code = 'nok'
      res.result.msg = 'search_id undefined'
      return res
    }
    const apiUrl = `${state.apiPreFix}/${state.search.device_id}/${state.search.id}/status` // TAMS (device_id)
    const apiParams = { data: { request_id: state.search.id }, loading: false }
    if (keepAlive) { // Keep Alive 요청 시 REST API의 모든 에러 메세지 차단
      apiParams.successAlert = false
      apiParams.isSkipNotFound = true
      apiParams.isNotShowErrorAlert = true
    }
    try {
      res = await this.$axios.$get(apiUrl, apiParams)
      if (keepAlive) return // Keep Alive는 요청 후 바로 리턴
      if (res.code === 'ok') state.searchState = res.result
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },
  // 로그 조회가 완료 / 중지되면 현재까지 검색된 로그 데이터를 요청한다. (실제 화면에 출력하는 데이터)
  async getSearchResult ({commit, state}, {start, end, page}) {
    let res = { code: 'ok', result: {} } // TAMS
    if (state.search.id === undefined || state.search.id === '') {
      res.code = 'nok'
      res.result.msg = 'search_id undefined'
      return res
    }
    const apiUrl = `${state.apiPreFix}/${state.search.device_id}/${state.search.id}${'/page/'}${start}/to/${end}` // TAMS (device_id)
    try {
      res = await this.$axios.$get(apiUrl, {
        data: {request_id: state.search.id},
        loading: false,
        transformResponse: [(data) => { return JSONBigInt.parse(data) }]
      })
      if (res.code === 'ok') {
        if (!page) commit('appendLogDataList', res.result.log)
        else commit('updateLogDataList', res.result.log)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },
  // 로그 조회 중지를 요청한다. 로그 중지를 요청해도 RequestId는 초기화되지 않는다.
  async stopSearch ({state}) {
    let res = { code: 'ok', result: {} } // TAMS
    const apiUrl = `${state.apiPreFix}/${state.search.device_id}/${state.search.id}/stop` // TAMS (device_id)
    try {
      res = await this.$axios.$delete(apiUrl, {data: {request_id: state.search.id}, loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그 조회 완료를 요청한다. RequestId가 초기화된다. 로그 재검색 시 호출된다, TAMS (state.search.id -> id)
  async endSearch ({commit, state}, id) {
    let res = { code: 'ok', result: {} } // TAMS
    if ((id === undefined || id === '') &&
      (state.search.id === void 0 || state.search.id === '')) {
      res.code = 'nok'
      res.result.msg = 'search_id undefined'
      return res
    }

    const reqId = id || state.search.id
    state.search.end_id = reqId
    const apiUrl = `${state.apiPreFix}/${state.search.device_id}/${reqId}/end` // TAMS (device_id)
    try {
      res = await this.$axios.$delete(apiUrl, {data: {request_id: reqId}, loading: false, successAlert: false, errorAlert: false})

      if (res.code === 'ok') {
        commit('endSearch', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 전달된 UUID의 HA 멤버로 조회 End 요청을 수행한다.
  async endSearchHaMember ({commit, state}, {haPort, selectedUuid}) {
    let res = { code: 'ok', result: {} } // TAMS
    if (state.search.id === undefined || state.search.id === '' || selectedUuid === '') { // 조회 ID가 없거나, 대상 HA UUID가 빈 문자열인 경우 리턴
      res.code = 'nok'
      res.reason = 'Search id or ha member uuid is undefined.'
      return res
    }
    const reqId = state.search.id
    state.search.end_id = reqId
    const apiUrl = `/ha:${haPort}:${selectedUuid}${state.apiPreFix}/${reqId}/end`
    try {
      res = await this.$axios.$delete(apiUrl, {data: {request_id: state.search.id}, loading: false, successAlert: false, errorAlert: false})
      if (res.code === 'ok') commit('endSearch', res.result)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그 조회 상태에서 다음 검색된 로그가 있으면, 다음 로그를 요청한다.
  async nextSearch ({state}) {
    let res = { code: 'ok', result: {} } // TAMS
    if (state.search.id === undefined || state.search.id === '') {
      res.code = 'nok'
      res.reason = 'search_id undefined'
      return res
    }
    const apiUrl = `${state.apiPreFix}/${state.search.id}/page/next`
    try {
      res = await this.$axios.$get(apiUrl, {
        loading: false, successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },
  // 현재상태 리로드
  async reLoadStatus ({commit, state}, param) {
    try {
      const result = await this.$axios.$post(state.processStatusApiPath['RELOAD'], param, {applyMsg: true})
      if (result.code === 'ok') return true
    } catch (e) {}
    return false
  },
  /*
    이름: reStartStatus
    설명: 프로세스를 재시작한다. 로딩 팝업과 적용 메세지는 출력하지 않는다.
  */
  async reStartStatus ({commit, state}, param) {
    try {
      const result = await this.$axios.$post(state.processStatusApiPath['RESTART'], param, {
        loading: false, successAlert: false
      })
      if (result.code === 'ok') {
        return true
      }
    } catch (e) {}
    return false
  },
  // 프로토콜 조회
  async getProtocolList ({commit, state}, isAny = false) {
    const {code, result} = await this.$axios.$get(`api/op/service/protocols`)
    if (code === 'ok') commit('setProtocolList', {result: result, isAny: isAny})
  },
  // 삭제 (delFlag === ''), 조건 삭제 (delFlag === 'Condition'), 전체 삭제 (delFlag = ALL) 기능
  async deleteStatus ({commit, state}, delFlag = '') {
    try {
      const {apiPath, param} = getDeleteApiParam(state, delFlag)
      const data = await this.$axios.$delete(apiPath, {data: param})
      if (data.code === 'ok') return true
    } catch (e) {}
    return true
  },
  // [방화벽 상태] 현재상태 사용자 로그아웃, 전체 로그아웃 (flag = 'ALL')
  async userLogout ({commit, state}, flag = '') {
    let param = {}
    try {
      if (flag === '') {
        param = {
          usr_id: state.selectedItem[0].user_id,
          ip: state.selectedItem[0].access_ip
        }
      }
      const data = await this.$axios.$delete(state.fw_userauthApiPath['LOGOUT'], {data: param})
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [방화벽 상태] 현재상태 사용자 조건 삭제
  async userDelete ({commit, state}) {
    try {
      const data = await this.$axios.$delete(state.fw_userauthApiPath['DELETE'], {data: state.delUserCriteriaParam})
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [방화벽 상태] 인증 사용자 - 인증 사용자 수동 추가
  async userManualAdd ({commit, state}) {
    try {
      const data = await this.$axios.$post(state.fw_userauthApiPath['AUTH_USERS'], state.fw_authUsersParam)
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [방화벽 상태] 인증 사용자 - 인증 사용자 배치 이력 조회
  async getUserBatchHistory ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.fw_userauthApiPath['AUTH_USER_BATCH_HISTORY'])
      if (code === 'ok') {
        commit('getUserBatchHistory', result)
        return true
      }
    } catch (e) {}
    return false
  },
  // [방화벽 상태] 인증 사용자 - 인증 사용자 복구
  async setUserRestore ({commit, state}, param) {
    try {
      return await this.$axios.$post(state.fw_userauthApiPath['AUTH_USER_RESTORE'], param, {applyMsg: true})
    } catch (e) {}
    return false
  },
  // [HA 상태] HA 가상 IP - 수동 장애 복구
  async applyHaManualRecovery ({commit, state}) {
    try {
      const apiPath = state.dataType.toUpperCase(), postParam = {}
      let param = {}, isSuccessAlert = true
      if (state.dataType === 'ha_status') {
        param = _.cloneDeep(state.haUserParam)
        postParam.user_passwd = btoa(param.user_passwd)
        isSuccessAlert = false
      }
      const data = await this.$axios.$post(state.ha_resetApiPath[apiPath], postParam, {successAlert: isSuccessAlert, applyMsg: true})
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [VPN 상태] VPN 재시작
  async reStartVpn ({commit, state}) {
    try {
      const data = await this.$axios.$post(state.vpn_restartApiPreFix, '', {applyMsg: true})
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [방화벽 상태] 방화벽 현재 세션- 정책 자동 생성
  async policyAutoCreate ({commit, state}) {
    try {
      const param = _.cloneDeep(state.policyAutoCreateParam)
      if (state.policyAutoCreateGui.srcPortAny === 0) { // 출발지 Port Any 선택시
        param.src_port = '*'
      } else {
        param.src_port = `${param.src_port}` // Int -> String 변환
      }
      if (state.policyAutoCreateGui.dstPortAny === 0) param.dst_port = '*' // 목적지 Port Any 선택시
      else param.dst_port = `${param.dst_port}` // Int -> String 변환
      const data = await this.$axios.$post(state.policyAutoCreatePreFix, param)
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // [콘텐츠 보안 상태] APT-DB/URL 신고기능
  async setContentAptNotify ({commit, state}, item) {
    try {
      let param = {}
      if (state.dataType === 'apt_db_file_info') param = { analyzer: 'CLOUD', hash: item.sha256 }
      else if (state.dataType === 'apt_db_url_info') param = { analyzer: 'CLOUD', path: item.url }
      const data = await this.$axios.$post(state.contentAptNotifyPreFix, param, {applyMsg: true})
      if (data.code === 'ok') return true
    } catch (e) {}
    return false
  },
  // 콘텐츠 보안 > APT / URL DB 항목의 사용 여부를 설정한다.
  async setEnableContentAptUrlDb ({state, commit}, params) {
    try {
      // APT DB / URL DB 사용 여부를 설정하는 API 호출
      await this.$axios.$put(state.contentAptDbBehaviorBased, params, {loading: true, applyMsg: true})
    } catch (e) { return false } // REST API 요청 중 예외가 발생하면 return false (실패 시)
    return true // 결과가 성공하면  True
  },
  // 파일 업로드
  async fileUpload ({commit, state}, file) {
    try {
      return await this.$axios.$post(`/api/co/file/import`, file)
    } catch (e) {}
    return false
  },
  // 배치 실행
  async runAddBatch ({commit, state}, file) {
    try {
      return await this.$axios.$post(`/api/po/auth/users/batch`, file)
    } catch (e) {}
    return false
  },
  async fileSave ({state}, param) {
    const sendParam = _.clone(state.searchData)
    sendParam.titles = param.value
    const apiUrl = `${state.apiPreFix}/${state.search.device_id}/save` // TAMS (device_id)
    const {data, fileName} = await this.$axios.$file(apiUrl, sendParam, {
      responseType: 'blob', successAlert: false, errorMsg: state.logDetailDownErr
    })
    pcDownloadFile(data, fileName)
  },
  // FileName을 전달 받아 PC Download 수행
  async downloadSave ({commit, state}, _filename) {
    const {data, fileName} = await this.$axios.$file(state.fw_userauthApiPath['AUTH_USER_BATCH_HISTORY'], {filename: _filename}, {
      responseType: 'blob', successAlert: false, errorMsg: state.logDetailDownErr
    })
    pcDownloadFile(data, fileName)
  },
  // NAT 고급 설정 조회
  async getNatConfig ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.natConfigPreFix)
    if (code === 'ok') commit('getNatConfig', result)
  },
  // NAT V6 고급 설정을 조회
  async getNatV6Config ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.natV6ConfigPrefix)
    if (code === 'ok') commit('setNatV6Config', result)
  },
  //  [시스템 상태-현재접속중인 관리자] Level3 계정인 경우 타 계정 로그 아웃 수행
  async accessUserLogout ({commit, state}, item) {
    try {
      const data = await this.$axios.$delete(`${state.accessUserLogoutPreFix}/${item.admin_id}`, {alertMsg: i18n.t('msg.userLogoutResult')})
      if (data.code === 'ok') {
        return true
      }
    } catch (e) {}
    return false
  },
  // 가상 IP 소유권 설정값을 리턴한다.
  async getVipManualFailOver ({state, commit}) {
    try {
      const {code, result} = await this.$axios.$get(state.aptFailOverPath)
      if (code === 'ok') {
        commit('setVipFailOverMode', result.vip_manual_failover_mode || 0)
        return true
      }
    } catch (e) {}
    return false
  },
  // 가상 IP 소유권 설정값을 리턴한다.
  async setVipManualFailOver ({state, commit}, vipMode) {
    try {
      const {code, result} = await this.$axios.$put(state.aptFailOverPath, {
        vip_manual_failover_mode: vipMode
      })
      if (code === 'ok') {
        commit('setVipFailOverMode', result.vip_manual_failover_mode || 0)
        return true
      }
    } catch (e) {}
    return false
  },
  // Group VPN 터널 연결 상태를 리턴한다.
  async getGroupVpnConnStatus ({state}, {spi, dst_ip: dstIp}) {
    const res = { code: 'ok' }
    try {
      const {code, result} = await this.$axios.$get(`${state.apiPreFix}/groupvpn/tunnel/conn/status/ip/${dstIp}/spi/${spi}`)
      res.code = code
      res.result = result
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  // WIPS 센서 현재 상태 파일 다운로드
  async sensorStatusFileSave ({state}) {
    const res = { code: 'ok' }
    const errMsg = ''
    try {
      const {data, fileName} = await this.$axios.$file(`${state.wipsSensorStatusPrefix}/down`, state.wipsLastSearchOpt, {
        responseType: 'blob', successAlert: false, errorMsg: errMsg
      })
      pcDownloadFile(data, fileName)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = errMsg
    }
    return res
  }
}

// Any의 정보를 각 기능에 맞춰 변환
function convertAnyFormat (state) {
  state.delConditionParam.fw_rule_id = getAnyCheck(state.delConditionGui.fwIdAny, state.delConditionParam.fw_rule_id) // fwId
  state.delConditionParam.vlan = getAnyCheck(state.delConditionGui.vlanIdAny, state.delConditionParam.vlan) //           vlanId
  state.delConditionParam.nat_rule_id = getAnyCheck(state.delConditionGui.natruleIdAny, state.delConditionParam.nat_rule_id) // nat_rule_id
  state.delConditionParam.sip = getAnyCheck(state.delConditionGui.srcIpAny, state.delConditionParam.sip) //               출발지 주소
  state.delConditionParam.sip_mask = getAnyCheck(state.delConditionGui.srcIpAny, state.delConditionParam.sip_mask) //     출발지 주소 mask
  state.delConditionParam.sport = getAnyCheck(state.delConditionGui.srcPortAny, state.delConditionParam.sport) //         출발지 포트
  state.delConditionParam.dip = getAnyCheck(state.delConditionGui.dstIpAny, state.delConditionParam.dip) //               목적지 주소
  state.delConditionParam.dip_mask = getAnyCheck(state.delConditionGui.dstIpAny, state.delConditionParam.dip_mask) //     목적지 주소 mask
  state.delConditionParam.dport = getAnyCheck(state.delConditionGui.dstPortAny, state.delConditionParam.dport) //         목적지 포트
}

function getAnyCheck (isAny, value) {
  if (isAny === 0) return null
  return value
}

// any 정보를 각 기능에 맞는 형태로 변환하여 Return
function getAnyDefault (value, defaultValue) {
  if (value.toLowerCase() === 'any' || value.toLowerCase() === '-') return defaultValue
  return value
}

function convertPort (value) {
  if (value.toLowerCase() === 'any') return [0, 65535]
  else if (value.indexOf('-') < 0) return [value, value]
  return value.split('-')
}

// 객체 정보인 경우 괄호 ()안에 있는 정보를 Return
function convertIp (targetIp) { // IP -> IP , [] 객체정보 (IP) -> IP
  if (targetIp.indexOf('(') >= 0) {
    const splitIp = targetIp.split('(')
    return splitIp[0].trim()
  }
  return targetIp
}

// 출발지, 목적지 포트가 - 인경우 -> * 로 Return
function convertAnyPort (value) {
  if (value.trim() === '-') return '*'
  return value
}
export const getters = {}
export const strict = false
